module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-22-b26c2c9bc64d44de82d5774bc0ac2938.jpg";